import { MessageSquare } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Textarea } from '@/components/ui/textarea';

/** One-line amber preview of a collapsed split's remark; clicking it opens the split. */
export function RemarkLine({
    remark,
    onOpen,
    testId,
}: {
    remark: string;
    onOpen: () => void;
    testId: string;
}) {
    return (
        <button
            type="button"
            title={remark}
            className="mx-3 mb-2 flex w-[calc(100%-24px)] items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-2 py-1 text-left text-xs text-amber-900"
            onClick={onOpen}
            data-testid={testId}
        >
            <MessageSquare
                aria-hidden="true"
                className="mt-px h-3 w-3 shrink-0 text-amber-700"
            />
            <span className="min-w-0 truncate">{remark}</span>
        </button>
    );
}

/** The reviewer's remark box inside an open split; typing in it leaves the Verified tick alone. */
export function RemarkField({
    id,
    value,
    noun,
    onChange,
    onBlur,
    testId,
}: {
    id: string;
    value: string;
    noun: 'document' | 'sheet';
    onChange: (value: string) => void;
    onBlur?: () => void;
    testId: string;
}) {
    return (
        <div className="flex flex-col gap-1 text-xs text-slate-600">
            <label htmlFor={id}>
                Remark{' '}
                <span className="text-slate-500">(optional, for the next reviewer)</span>
            </label>
            <Textarea
                id={id}
                rows={2}
                value={value}
                placeholder={`What should the next reviewer know about this ${noun}?`}
                className={cn(
                    'min-h-14 px-2 py-2 text-sm',
                    value.trim() && 'border-amber-200 bg-amber-50',
                )}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                data-testid={testId}
            />
            <span className="text-slate-500">
                Saved with the {noun}. Does not untick Verified.
            </span>
        </div>
    );
}
